var _path, _circle, _circle2, _circle3, _circle4, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSoftwareAndSaasDevelopmentIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 31,
    viewBox: "0 0 42 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.3887 28C37.0831 28 40.8887 24.1944 40.8887 19.5C40.8887 15.5728 38.2253 12.2676 34.6063 11.2922C33.3604 5.41216 28.1398 1 21.8887 1C16.228 1 11.4124 4.618 9.62803 9.6677C4.82996 9.86276 1 13.8142 1 18.6602C1 23.6307 5.02944 27.6602 10 27.6602C11.9438 27.6602 16.3887 27.6602 18.3887 27.6602",
    stroke: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30.3887,
    cy: 28.5,
    r: 2,
    stroke: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 28.3887,
    cy: 16.5,
    r: 2,
    stroke: "white"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 21.3887,
    cy: 10.5,
    r: 2,
    stroke: "white"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 13.3887,
    cy: 16.5,
    r: 2,
    stroke: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8887 27.5V20.9142C17.8887 20.649 17.7833 20.3946 17.5958 20.2071L15.3887 18M21.3887 27V13M24.8887 27V20.9142C24.8887 20.649 24.994 20.3946 25.1816 20.2071L26.8887 18.5",
    stroke: "white",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSoftwareAndSaasDevelopmentIcon);
export default __webpack_public_path__ + "static/media/softwareAndSaasDevelopmentIcon.ebee56bb099d1acf1b62c245d93515cc.svg";
export { ForwardRef as ReactComponent };